import { bannerCopy, RECOVERY_STATUS } from "../meeting/recoveryPlan";

export function AudioRecoveryBanner({ status, detail, onRestore, onRejoin }) {
  if (!status || status === RECOVERY_STATUS.CONNECTED) return null;

  const copy = bannerCopy(status);
  const showRestore =
    status === RECOVERY_STATUS.INTERRUPTED ||
    status === RECOVERY_STATUS.MIC_UNAVAILABLE ||
    status === RECOVERY_STATUS.RESTORING;
  const restoreDisabled = status === RECOVERY_STATUS.RESTORING;

  return (
    <div
      className="pointer-events-auto absolute left-1/2 top-16 z-[60] w-[min(92vw,26rem)] -translate-x-1/2 rounded-2xl bg-white/95 p-3 text-biz-ink shadow-panel ring-1 ring-black/5 sm:top-[4.5rem] sm:p-4"
      role="status"
      aria-live="polite"
    >
      <p className="font-display text-base font-semibold leading-tight">{copy.title}</p>
      <p className="mt-1 text-xs leading-relaxed text-biz-mute">{detail || copy.body}</p>
      <div className="mt-3 flex gap-2">
        {showRestore ? (
          <button
            type="button"
            className="rounded-xl bg-biz-yellow px-3 py-2 text-xs font-semibold text-biz-ink disabled:opacity-50"
            onClick={onRestore}
            disabled={restoreDisabled}
          >
            Restore audio
          </button>
        ) : null}
        {typeof onRejoin === "function" ? (
          <button
            type="button"
            className="rounded-xl border border-biz-line px-3 py-2 text-xs font-semibold text-biz-forest"
            onClick={onRejoin}
          >
            Rejoin meeting
          </button>
        ) : null}
      </div>
    </div>
  );
}
